import React, { useState, useRef, useEffect } from 'react';
import { messagingStatusOptions } from '../../utils/messagingStatusParse';
import styles from '../StatusSelector/style.module.css';

const MessagingStatusSelector = ({
  selectedStatus = [],
  handleStatusChange = () => { },
  label = 'Status mensageria',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleCheckboxChange = (value, e) => {
    e.stopPropagation();
    if (!handleStatusChange) return;

    const next = selectedStatus.includes(value)
      ? selectedStatus.filter((status) => status !== value)
      : [...selectedStatus, value];

    handleStatusChange(next);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getSelectedText = () => {
    if (!selectedStatus?.length) return 'Selecione um status';
    if (selectedStatus.length === 1) {
      const selected = messagingStatusOptions.find((opt) => opt.value === selectedStatus[0]);
      return selected ? selected.label : '1 status selecionado';
    }
    return `${selectedStatus.length} status selecionados`;
  };

  return (
    <div className={styles.selectorContainer} ref={wrapperRef}>
      {label && <label>{label}</label>}
      <div className={isOpen ? `${styles.selectWrapper} ${styles.active}` : styles.selectWrapper}>
        <div className={styles.selectedDisplay} onClick={toggleDropdown}>
          <span>{getSelectedText()}</span>
          <span className={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
        </div>
        <div className={styles.checkboxList}>
          {messagingStatusOptions.map((option) => (
            <label
              key={option.value}
              className={styles.checkboxItem}
              onClick={(e) => e.stopPropagation()}
            >
              <input
                type="checkbox"
                checked={selectedStatus?.includes(option.value)}
                onChange={(e) => handleCheckboxChange(option.value, e)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MessagingStatusSelector;